import { Link } from "react-router-dom";
import { yen } from "../lib/api";
import { useI18n, catLabel } from "../lib/i18n";
import { NewBadge } from "./NewBadge";
import { ShareProductButton } from "./ShareProductButton";
import { Info } from "lucide-react";
import { jstToday } from "../lib/jst";

export const ProductCard = ({ product: p, onPick, testid, compact = false }) => {
  const { t, lang } = useI18n();
  const out = p.track_stock && p.stock <= 0;
  const desc = (lang === "ja" && p.description_ja) || p.description;
  const name = (lang === "ja" && p.name_ja) || p.name;
  return (
    <div
      className={`relative ${compact ? "shrink-0 w-[170px] sm:w-[190px]" : ""}`}
      data-testid={`${testid}-wrap`}
    >
      <button
        data-testid={testid}
        disabled={out}
        onClick={() => onPick(p)}
        className="w-full text-left bg-white border border-gray-100 shadow-sm rounded-xl overflow-hidden hover:-translate-y-1 hover:shadow-md transition-all duration-200 active:scale-95 disabled:opacity-40 disabled:hover:translate-y-0"
      >
        <div className="aspect-[4/3] bg-gray-100 overflow-hidden">
          {p.image_url ? (
            <img
              src={p.image_url}
              alt={name}
              loading="lazy"
              className="h-full w-full object-cover"
            />
          ) : (
            <div className="h-full w-full grid place-items-center text-gray-300 text-xs">
              {p.category}
            </div>
          )}
        </div>
        <div className={compact ? "p-3" : "p-4"}>
          <p className="text-xs text-muted-foreground">{catLabel(p.category, lang)}</p>
          <p className="font-medium leading-snug mt-1 line-clamp-2">{name}</p>
          {desc ? (
            <p
              className="text-xs text-muted-foreground line-clamp-2 mt-0.5"
              data-testid={`${testid}-desc`}
            >
              {desc}
            </p>
          ) : (
            <p className="text-xs text-muted-foreground" data-testid={`${testid}-weight`}>
              {p.weight || ""}
            </p>
          )}
          <div className="flex items-end justify-between mt-2 gap-2">
            <span className="num text-lg font-semibold">{yen(p.price)}</span>
            <span className="text-xs text-muted-foreground">
              {out ? t("out_of_stock") : `/ ${p.unit}`}
            </span>
          </div>
        </div>
      </button>
      <NewBadge show={p.is_new} />
      {p.today_date && p.today_date === jstToday() && (
        <span
          data-testid={`${testid}-today-badge`}
          className="absolute top-2 left-2 rounded-full bg-amber-500 text-white text-[10px] font-bold px-2 py-1 shadow-sm"
        >
          MENU HARI INI
        </span>
      )}
      <ShareProductButton product={p} testid={`${testid}-share`} />
      <Link
        to={`/produk/${p.id}`}
        data-testid={`${testid}-detail`}
        title={t("detail_link")}
        aria-label={t("detail_link")}
        className="absolute top-2 right-11 grid place-items-center h-8 w-8 rounded-full bg-white/90 text-gray-700 shadow-sm hover:bg-white hover:scale-110 transition-all duration-200"
      >
        <Info size={15} />
      </Link>
    </div>
  );
};
